__turbopack_context__.v({
  "bentoContent": "DayAndNight-module__Rh4gTW__bentoContent",
  "bentoImage": "DayAndNight-module__Rh4gTW__bentoImage",
  "bentoWrapper": "DayAndNight-module__Rh4gTW__bentoWrapper",
  "canvas": "DayAndNight-module__Rh4gTW__canvas",
  "container": "DayAndNight-module__Rh4gTW__container",
  "customSubtitleWrapper": "DayAndNight-module__Rh4gTW__customSubtitleWrapper",
  "fallbackImage": "DayAndNight-module__Rh4gTW__fallbackImage",
  "gradientSection": "DayAndNight-module__Rh4gTW__gradientSection",
  "gradientSequenceContainer": "DayAndNight-module__Rh4gTW__gradientSequenceContainer",
  "overlayInner": "DayAndNight-module__Rh4gTW__overlayInner",
  "sequenceCanvas": "DayAndNight-module__Rh4gTW__sequenceCanvas",
  "sequenceStickyWrapper": "DayAndNight-module__Rh4gTW__sequenceStickyWrapper",
  "shootingStarsContainer": "DayAndNight-module__Rh4gTW__shootingStarsContainer",
  "stickyInner": "DayAndNight-module__Rh4gTW__stickyInner",
  "stickyOverlayAbs": "DayAndNight-module__Rh4gTW__stickyOverlayAbs",
});
